import { css, cx } from "@emotion/css";
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import { borderRadius, fontSize, themeTokens } from "@octopusdeploy/design-system-tokens";
interface CodeEditorSelectProps<T extends string> {
    supportedLanguages: Array<T>;
    scriptingLanguage: T;
    onChange: (value: T) => void;
    onFocus: () => void;
    onClose?: () => void;
    onOpen?: () => void;
}
export function CodeEditorSelect<T extends string>(props: CodeEditorSelectProps<T>) {
    return (<Select value={props.scriptingLanguage} className={cx(codeEditorToolbarSelectStyles, selectRoot)} onFocus={() => props.onFocus()} 
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    onChange={(event) => props.onChange(event.target.value as T)} onClose={() => props.onClose?.()} onOpen={() => props.onOpen?.()} variant="standard">
            {props.supportedLanguages.map((language) => (<MenuItem key={language} value={language}>
                    {language}
                </MenuItem>))}
        </Select>);
}
export const codeEditorToolbarSelectStyles = css({
    margin: 0,
    height: "34px",
    "& > div": {
        color: themeTokens.color.text.primary,
        fontSize: fontSize["medium"],
        borderRadius: borderRadius.small,
        margin: 0,
        cursor: "pointer",
    },
});
const selectRoot = css({
    border: `1px solid ${themeTokens.color.border.tertiary}`,
    borderRadius: borderRadius.medium,
    background: themeTokens.color.codeEditor.toolbar.background,
    width: "180px",
    ".MuiSelect-select": {
        paddingLeft: "8px",
        paddingTop: "5px",
    },
    ".MuiSelect-icon": {
        color: themeTokens.color.icon.primary,
    },
    "&.MuiInput-underline::before, &.MuiInput-underline:hover:not(.Mui-disabled)::before": {
        borderBottom: "none",
    },
    "&.MuiInput-underline::after": {
        borderBottom: "none",
    },
});
